import React, { useState, useEffect, useContext } from "react";
import Pagination from "rc-pagination";
import Box from "../../common/Box";
import Helmet from "react-helmet";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Loader from "utils/Loader";

import "./transaction.scss";
import {
  FaCheckCircle,
  FaRegPlusSquare,
  FaRegMinusSquare,
  FaPlus,
  FaMinus,
  FaCheck,
} from "react-icons/fa";
import { HiOutlineBan } from "react-icons/hi";
import { ToastContainer, toast } from "react-toastify";
import CreatableSelect from "react-select";
import logo from "assets/images/sitelogo.svg";
import logo1 from "assets/images/financ2.png";
import logo2 from "assets/images/financ3.png";
import logo3 from "assets/images/financ5.png";
import ReactTooltip from "react-tooltip";

import "react-toastify/dist/ReactToastify.css";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
// import {
//   TransferToCard,
//   TransactionRecords,
//   date,
//   inventory,
//   Charg,
// } from "./transactions.js";
import { useParams } from "react-router-dom";
import { connection } from "../../utils/apiConnection.ts";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import Card from "../Card/Card.jsx";
// import toast from "react-hot-toast";

// import { showSwalError, showSwalSuccess } from "../../utilities/swal";

const date = (TimeStamp) => {
  let options = { year: "numeric", month: "numeric", day: "numeric" };
  let date = new Date(parseInt(TimeStamp) * 1000);

  let FaDate = date.toLocaleDateString("fa-IR", options);
  FaDate.replace(/([۰-۹])/g, (token) =>
    String.fromCharCode(token.charCodeAt(0) - 1728)
  );
  return [date.getHours(), date.getMinutes(), FaDate, date];
};

function Transa({ info, key, type, setUpdater, updater }) {
  const [dateValue, setDateValue] = useState("");
  const [inputValue, setInputValue] = useState("");

  const send = () => {
    if (inputValue == "") {
      toast.error("لطفا کد را وارد کنید!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      connection("api3/withdraw", {
        tracking_code: inputValue,
        amount: info["amount"],
        walletId: info["from_wallet_id"],
        walletTransaction: info["id"],
      }).then((res) => {
        if (res.status) {
          setUpdater(!updater);
        } else {
          toast.error("مشکلی وجود دارد لطفا دوباره امتحان کنید!", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
    }
  };

  useEffect(() => {
    setDateValue(date(info.mtm));
  }, []);

  return (
    <div
      className={`d-flex flex-row px-3 my-3  mx-1 transaction-card shadow ${
        !(info.type == 3 && type == 0 && info.main_status != 2) &&
        "border border-success border-4"
      } `}
      style={{
        borderRadius: "10px",
      }}
    >
      <div className="d-flex flex-column  justify-content-around w-100">
        <div
          className="d-flex flex-column justify-content-between flex-wrap "
          style={{ height: "140px" }}
        >
          {type == 0 && info.lname && (
            <div className="mt-1">
              <span>{info.fname + " " + info.lname}</span>
            </div>
          )}
          {info.type == 0 ? (
            <div>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>شارژ حساب</h5>
                </div>
                <div>
                  <h5>{addCommas(info.amount)}</h5>
                </div>
              </div>
            </div>
          ) : info.type == 1 ? (
            <div>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>خرید از حساب</h5>
                </div>
                <div>
                  <h5>{info.from_wallet_id}</h5>
                </div>
              </div>
            </div>
          ) : info.type == 2 ? (
            <div>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>انتقال از حساب</h5>
                </div>
                <div>
                  <h5>{info.from_wallet_id}</h5>
                </div>
              </div>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>به</h5>
                </div>
                <div>
                  <h5>{info.to_wallet_id}</h5>
                </div>
              </div>
            </div>
          ) : info.type == 3 ? (
            <div>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>برداشت از حساب</h5>
                </div>
                <div>
                  <h5>{info.from_wallet_id}</h5>
                </div>
              </div>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>انتقال به شماره کارت</h5>
                </div>
                <div>
                  <h5>{info.tparams}</h5>
                </div>
              </div>
              {!(info.type == 3 && type == 0 && info.main_status != 2) && (
                <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                  <div>
                    <h5>کد رهگیری</h5>
                  </div>
                  <div>
                    <h5>{info.tracking_code}</h5>
                  </div>
                </div>
              )}
            </div>
          ) : null}

          {/* 
            0=>شارژ
            1=>خرید
            2=>انتقال داخلی
            3=> برداشت
          */}
        </div>
        {info.type == 3 && type == 0 && info.main_status != 2 && (
          <>
            <input
              value={inputValue}
              type="number"
              onChange={(e) => setInputValue(e.target.value)}
              className="form-control"
              placeholder="کد رهگیری را وارد کنید"
            />
            <button
              onClick={() => {
                send();
              }}
              className="btn btn-success mt-2"
            >
              تایید
            </button>
          </>
        )}

        <div
          className="d-flex flex-row align-items-center py-2 justify-content-between  flex-wrap "
          style={{
            height: "70px",
            borderTop:
              !(info.type == 3 && type == 0 && info.main_status != 2) &&
              "3px solid green",
          }}
        >
          <h5 className="d-flex justify-content-between w-100 flex-row-reverse">
            <span>{date(info.mtm)[2]}</span>
            <span>{`${date(info.mtm)[0]}:${date(info.mtm)[1]}`}</span>
          </h5>
          <h5 className="date-card1 d-flex justify-content-between w-100">
            {addCommas(info.amount.toLocaleString())} تومان
          </h5>
        </div>
      </div>
    </div>
  );
}

function LineTransaction({ info, key, type, setUpdater }) {
  const [dateValue, setDateValue] = useState("");
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setDateValue(date(info.mtm));
  }, [info]);

  return (
    <div
      className="d-flex flex-row px-3 my-3  mx-1 transaction-card border border-primary shadow w-100 p-2 "
      style={{
        borderRadius: "10px",
      }}
    >
      <div className=" w-100 ">
        <div className=" flex-wrap ">
          {info && (
            <>
              <span>{info.fname}</span>
              <span className="">{info.lname} </span>
              {info.type == 0 && info.main_status == 0 ? (
                <>
                  <span className="mx-1"> شارژ حساب </span>
                  <span>
                    {info.to_wallet_info.title
                      ? " " + info.to_wallet_info.title
                      : " " +
                        info.to_wallet_info.fname +
                        " " +
                        info.to_wallet_info.lname}{" "}
                  </span>
                </>
              ) : info.type == 1 && info.main_status == 0 ? (
                <>
                  <span className="mx-1"> خرید با حساب </span>
                  <span>
                    {" "}
                    {info.from_wallet_info.title
                      ? " " + info.from_wallet_info.title
                      : " " +
                        info.from_wallet_info.fname +
                        " " +
                        info.from_wallet_info.lname}
                  </span>
                </>
              ) : info.type == 2 && info.main_status == 0 ? (
                <>
                  <span className="mx-1"> انتقال از حساب </span>
                  <span> سوپرادمین </span>
                  <span className="mx-1"> به حساب </span>
                  <span>
                    {info.from_wallet_info.title
                      ? " " + info.from_wallet_info.title
                      : " " +
                        info.from_wallet_info.fname +
                        " " +
                        info.from_wallet_info.lname}
                  </span>
                </>
              ) : info.type == 3 && info.main_status == 2 ? (
                <>
                  <span className="mx-1"> برداشت از حساب </span>
                  <span>
                    {info.from_wallet_info.title
                      ? " " + info.from_wallet_info.title
                      : " " +
                        info.from_wallet_info.fname +
                        " " +
                        info.from_wallet_info.lname}
                  </span>
                  <span className="mx-1"> انتقال به شماره کارت </span>
                  <span>{info.tracking_code}</span>
                </>
              ) : info.type == 4 && info.main_status == 0 ? (
                <>
                  <span className="mx-1"> برگشت مبلغ به حساب </span>
                  <span>
                    {info.to_wallet_info.title
                      ? " " + info.to_wallet_info.title
                      : " " +
                        info.to_wallet_info.fname +
                        " " +
                        info.to_wallet_info.lname}{" "}
                  </span>
                </>
              ) : null}
              <span>در تاریخ </span>
              <span>{date(info.mtm)[2]}</span>
              <span> ساعت </span>
              <span>{`${date(info.mtm)[0]}:${date(info.mtm)[1]}`}</span>
              <span> به مبلغ </span>
              {addCommas(info.amount.toLocaleString())} تومان
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default function Transactions({
  type,
  otherInfo,
  logo,
  // , supplierId = 0
}) {
  //type :0= Admin 1=Customer 2=provider
  const [style, setstyle] = useState([true, false, false, false, true]);
  const [CostButton, setCostButton] = useState([false, false, false]);
  const [costInput, setcostInput] = useState("0");
  const [Input1, setInput1] = useState("");
  const [Input2, setInput2] = useState("");
  const [records, setRecords] = useState([]);
  const [update, setUpdate] = useState(true);
  const [current_inventor, setCurrent_inventor] = useState(0);
  const [Transactions, setTransactions] = useState([]);
  const [Transactions2, setTransactions2] = useState([]);
  const [Key, setKey] = useState(true);
  const [bank, setBank] = useState([]);
  const [cards, setCards] = useState([]);
  const [selectNumber, setSelectNumber] = useState([]);
  const auth = useContext(WithAuthentication);
  const [currentPage, setCurrentPage] = useState(1);
  const [time, setTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [chang, setChang] = useState(true);
  const [updater, setUpdater] = useState(true);
  const [walletId, setWalletId] = useState("");
  const [toWallet, setToWallet] = useState("");
  const [fromWallet, setFromWallet] = useState("");
  const [allWallets, setAllWallet] = useState([]);
  const [toAllWallets, setToAllWallets] = useState("");
  const [fromAllWallets, setFromAllWallets] = useState("");
  const [valid, setValid] = useState([false, false]);
  const [current_inventorAllWallets, setCurrent_inventorAllWallets] =
    useState("");
  const supplier_id = useParams();
  const supplierId = supplier_id.supplierId;
  const [addCard, setAddCard] = useState({
    card_number: "",
    shaba_number: "",
    card_owner_name: "",
    expiry_year: "",
    expiry_month: "",
    bank_name: "",
    wallet_id: "",
    bank_name: "",
    uid: auth.userInfo.id,
    account_type: type,
    status: "0",
  });

  const InventoryUpdate = () => {
    setCurrent_inventor((perv) => perv.parseInt - +Input2.parseInt);
  };

  async function TransferToCard(CartNumber, price, muid) {
    // console.log("secend step");
  }

  useEffect(() => {
    let Day = new Date();
    let date = new Date(parseInt(Day.getTime()));
    let FaDate = date.toLocaleDateString("fa-IR");
    // setTime(FaDate.split("/"));
    setTime(["", "", "10"]);

    if (type == 0) {
      connection("api3/wallets_info").then((res) => {
        if (res.status == 1) {
          setAllWallet(res.items);
          setToAllWallets(res.allToWallet);
          setFromAllWallets(res.allFromWallet);
          setCurrent_inventorAllWallets(res.allCurrentInventory);
        }
      });

      connection("api/Find_wallets", {
        conditions: `type/=/1`,
      }).then((res) => {
        setCurrent_inventor(res[0].current_inventory);
      });

      connection("api3/get_transaction", {
        walletId: 0,
      }).then((res) => {
        let array = [];
        if (res.status == 1) {
          res.items.map((item) => {
            if (item.main_status != 1 && item.type != 3) {
              array.push(item);
            }
          });
          setTransactions(array);
        }
      });

      connection("api3/input_output_wallets", {
        type: "0",
      }).then((res) => {
        if (res.status == 1) {
          let sum = 0;
          res.items.toWallet.map((item) => {
            sum = sum + parseInt(item.amount);
          });
          setToWallet(sum);
          sum = 0;
          res.items.fromWallet.map((item) => {
            sum = sum + parseInt(item.amount);
          });
          setFromWallet(sum);
        }
      });

      connection("api/Find_wallets_transactions", {
        conditions: "type/=/3@@transaction_type/=/0",
        // tbl_name: "left join,users,muid,id",
      }).then((res) => {
        let array = [];
        res.map((item) => {
          if (item.main_status == 0 || item.main_status == 2) {
            array.push(item);
          }
        });
        setTransactions2(array);
      });
    }

    if (type != 0) {
      let walletID = 0;
      let businessKey = true;
      if (type == 2) {
        connection("api/Find_businesses", {
          conditions: `id/=/${supplierId}`,
        }).then((res) => {
          if (res.length > 0) {
            if (parseInt(res[0].admin_id) != auth.userInfo.id) {
              businessKey = false;
              setLoading(true);
            }
          }
        });
      }

      if (businessKey) {
        connection("api/Find_wallets", {
          conditions: `uid/=/${
            type == 1 ? auth.userInfo.id : supplierId
          }@@type/=/ ${type == 1 ? "0" : "2"}`,
        }).then((res) => {
          setCurrent_inventor(res[0].current_inventory);
          setAddCard({
            ...addCard,
            wallet_id: res[0].id,
          });
          walletID = res[0].id;
          connection("api3/get_transaction", {
            walletId: walletID,
          }).then((res) => {
            let array = [];
            if (res.status == 1) {
              res.items.map((item) => {
                if (
                  item.main_status != 1 &&
                  !(item.type == 3 && item.main_status == 0)
                ) {
                  array.push(item);
                }
              });
              setTransactions(array);
            }
          });
          // connection("api/Find_wallets_transactions", {
          //   conditions: `type/=/3@@transaction_type/=/0@@muid/=/${
          //     type == 1 ? auth.userInfo.id : supplierId
          //   }@@from_wallet_id/=/${walletID}`,
          // }).then((res) => {
          //   let array = [];
          //   res.map((item) => {
          //     if (item.main_status == 2) {
          //       array.push(item);
          //     }
          //   });
          //   setTransactions2(array);
          // });
          setWalletId(res[0].id);
          connection("api/Find_cards", {
            conditions: `wallet_id/=/${res[0].id}`,
          }).then((data) => {
            let array = [];
            data.map((item) => {
              if (parseInt(item.status) == 3 || parseInt(item.status) == 1) {
                array.push(item);
                bank.push({
                  value: item.card_number,
                  label: item.bank_name + "-" + item.card_number,
                });
              }
            });
            setCards(array);
            setBank(bank);
          });
        });
      }

      connection("api3/input_output_wallets", {
        type: type,
        businessId: supplierId,
      }).then((res) => {
        if (res.status == 1) {
          let array = [];
          res.items.toWallet.map((item) => {
            if (item.main_status == 0) {
              array.push(item);
            }
          });
          res.items.fromWallet.map((item) => {
            if (item.main_status == 0) {
              array.push(item);
            }
          });
          let sum = 0;
          res.items.toWallet.map((item) => {
            sum += parseInt(item.amount);
          });
          setToWallet(sum);
          sum = 0;
          res.items.fromWallet.map((item) => {
            sum += parseInt(item.amount);
          });
          setFromWallet(sum);
        }
      });

      // connection("api/Find_wallets_transactions", {
      //   conditions: `/exists/(muid=${
      //     type == 1 ? auth.userInfo.id : supplierId
      //   } AND( from_wallet_id=${walletID} OR to_wallet_id=${walletID}))`,
      // }).then((res) => {
      //   let array = [];
      //   res.map((item) => {
      //     if (item.main_status == 0) {
      //       array.push(item);
      //     }
      //   });
      //   setTransactions(array);
      // });
    }
  }, [otherInfo, updater, update]);

  const click = (TAB) => {
    setstyle(
      style.map((value, index) => {
        if (index == TAB) {
          return true;
        } else {
          return false;
        }
      })
    );
  };

  const clickCost = (TAB) => {
    setCostButton(
      CostButton.map((value, index) => {
        if (index == TAB) {
          return !value;
        } else {
          return false;
        }
      })
    );
  };

  function TransferTo(input1, input2) {
    if (input1 == "" && input2 == "") {
      toast.error(
        <p className="text-center">
          <div>
            <img src={logo} style={{ width: "50px" }} />
          </div>
          مبلغ و شماره کارت را وارد کنید!
        </p>,
        {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
    } else {
      connection("api/Find_wallets", {
        conditions:
          type === 1 ? `uid/=/${auth.userInfo.id}` : `uid/=/${supplierId}`,
      }).then((fromWalletId) => {
        if (fromWalletId[0]["current_inventory"] <= 0) {
          toast.error(
            <p className="text-center">
              <div>
                <img src={logo} style={{ width: "50px" }} />
              </div>
              موجودی کافی نیست!
            </p>,

            {
              position: "top-center",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
        } else {
          connection("api/Find_wallets", {
            conditions: `type/=/1`,
          }).then((toWalletId) => {
            let mtm = new Date();
            mtm = parseInt(mtm.getTime() / 1000);

            connection("api/Insert_wallets_transactions", {
              type: 3,
              transaction_type: 0,
              amount: input2,
              from_wallet_id: fromWalletId[0]["id"],
              to_wallet_id: toWalletId[0]["id"],
              factor_id: 0,
              mtm: mtm,
              tparams: input1,
              main_status: 0,
              muid: auth.userInfo.id,
            }).then((res) => {
              if (res.status) {
                let result = res.result.id;

                connection("api/updatewalletsfortransfer", {
                  from_wallet_id: fromWalletId[0]["id"],
                  to_wallet_id: toWalletId[0]["id"],
                  amount: input2,
                }).then((res) => {
                  if (res.status == 1) {
                    setUpdate(!update);
                    toast.success(
                      <p className="text-center">
                        <div>
                          <img src={logo} style={{ width: "50px" }} />
                        </div>
                        درخواست ارسال شد
                      </p>,
                      {
                        position: "top-center",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                      }
                    );
                  } else {
                    toast.error(
                      <p className="text-center">
                        <div>
                          <img src={logo} style={{ width: "50px" }} />
                        </div>
                        مشکلی پیش آمده لطفا دوباره امتحان کنید!
                      </p>,
                      {
                        position: "top-center",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                      }
                    );
                  }
                  return res.status == 1;
                });
              } else {
                toast.error(
                  <p className="text-center">
                    <div>
                      <img src={logo} style={{ width: "50px" }} />
                    </div>
                    مشکلی پیش آمده لطفا دوباره امتحان کنید!
                  </p>,
                  {
                    position: "top-center",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  }
                );
              }
            });
          });
        }
      });
    }
  }

  const Charg = (cost) => {
    if (cost == 0) {
      toast.error(
        <p className="text-center">
          <div>
            <img src={logo} style={{ width: "50px" }} />
          </div>
          مبلغ را وارد کنید!
        </p>,
        {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
    } else {
      connection("api/charge_wallet", {
        pay_amount: cost,
        wallet_id: walletId,
        // callback: "/financial-department",
      }).then((data) => {
        if (data.status == 1) {
          window.location.href = `${data.url}`;
        } else {
          toast.error(
            <p className="text-center">
              <div>
                <img src={logo} style={{ width: "50px" }} />
              </div>
              مشکلی به وجود آمده لطفا دوباره امتحان کنید!
            </p>,
            {
              position: "top-center",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
        }
      });
    }
  };

  const UpdateCard = (id, statue) => {
    connection(`api/Update_cards`, {
      keyvalues: `status,${statue}`,
      conditions: `id/=/${id}`,
    }).then((data) => {
      if (data["status"] == 1) {
        setBank([]);
        setUpdater(!updater);
      }
    });
  };

  const [show, setShow] = useState(false);
  const AddCard = () => {
    console.log(addCard);
    let Valid = [false, false];
    let send = true;
    for (const key in addCard) {
      if (addCard[key] == "") {
        send = false;
      }
    }
    if (addCard["card_number"].length != 16) {
      send = false;
      Valid[1] = true;
    }
    if (addCard["shaba_number"].length != 24) {
      send = false;
      Valid[0] = true;
    }
    setValid(Valid);
    if (send) {
      connection(`api/Insert_cards`, addCard).then((data) => {
        if (data["status"]) {
          toast.success(
            <p className="text-center">
              <div>
                <img src={logo} style={{ width: "50px" }} />
              </div>
              کارت با موفقیت ثبت شد
            </p>,
            {
              position: "top-center",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
        } else {
          toast.error(
            <p className="text-center">
              <div>
                <img src={logo} style={{ width: "50px" }} />
              </div>
              مشکلی وجود دارد لطفا دوباره امتحان کنید
            </p>,
            {
              position: "top-center",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
        }
        handleClose();
      });
    } else {
      toast.error(
        <p className="text-center">
          <div>
            <img src={logo} style={{ width: "50px" }} />
          </div>
          لطفا تمام گزینه ها را وارد کنید
        </p>,
        {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
    }
  };

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
    setAddCard({
      card_number: "",
      shaba_number: "",
      card_owner_name: "",
      expiry_year: "",
      expiry_month: "",
      bank_name: "",
      wallet_id: walletId,
      bank_name: "",
      uid: auth.userInfo.id,
      account_type: type,
      status: "0",
    });
    setValid([false, false]);
  };

  return (
    <div
      className="bg-white m-0 rounded-3 mx-auto Transactions d-flex flex-column  mt-5"
      // style={{ border: "1px solid gray" }}
      style={{ width: "100%" }}
    >
      {loading ? <Loader /> : ""}

      <Helmet>
        <title>امور مالی</title>
        {/* <link rel="shortcut icon" href={`${logo}`} /> */}
      </Helmet>

      {type == 0 && (
        <div className="d-flex flex-wrap">
          <div className=" col-sm-4 col-6">
            <Card
              title="ورودی کیف پول ادمین"
              lightColor="#503E9D"
              darkColor="#281F4F"
              number={parseInt(toWallet).toLocaleString()}
              imgSrc={logo1}
              underline={false}
            ></Card>
          </div>
          <div className=" col-sm-4 col-6">
            <Card
              title="خروجی کیف پول ادمین"
              lightColor="#F2CC5B"
              darkColor="#B89B45"
              number={parseInt(fromWallet).toLocaleString()}
              imgSrc={logo2}
              underline={false}
            ></Card>
          </div>
          <div className=" col-sm-4 col-6">
            <Card
              title="مانده کیف پول ادمین"
              lightColor="#56A689"
              darkColor="#3E7763"
              number={parseInt(current_inventor).toLocaleString()}
              imgSrc={logo3}
              underline={false}
            ></Card>
          </div>

          <div className=" col-sm-4 col-6">
            <Card
              title="ورودی کیف پول کاربران"
              lightColor="#503E9D"
              darkColor="#281F4F"
              number={parseInt(toAllWallets).toLocaleString()}
              imgSrc={logo1}
              underline={false}
            ></Card>
          </div>
          <div className=" col-sm-4 col-6">
            <Card
              title="خروجی کیف پول کاربران"
              lightColor="#F2CC5B"
              darkColor="#B89B45"
              number={parseInt(fromAllWallets).toLocaleString()}
              imgSrc={logo2}
              underline={false}
            ></Card>
          </div>

          <div className=" col-sm-4 col-6">
            <Card
              title="مانده کیف پول کاربران"
              lightColor="#56A689"
              darkColor="#3E7763"
              number={parseInt(current_inventorAllWallets).toLocaleString()}
              imgSrc={logo3}
              underline={false}
            ></Card>
          </div>
        </div>
      )}

      <ul
        class="nav nav-tabs m-3  w-75  mx-auto "
        id="pills-tab"
        role="tablist"
        style={{ borderBottom: "2px solid #303481" }}
      >
        {type == 0 ? (
          <>
            <li class="nav-item" role="presentation">
              <a
                class="nav-link active btn buttonTAb"
                onClick={() => {
                  click(4);
                  setCurrentPage(1);
                }}
                data-style={style[4]}
                id="buttonTAb5"
                data-bs-toggle="tab"
                data-bs-target="#Tab5"
                type="button"
                role="tab"
                aria-controls="pills-profile5"
                aria-selected="false"
                style={{ padding: "3px 11px" }}
              >
                لیست کیف پول ها
              </a>
            </li>
          </>
        ) : (
          <>
            <li class="nav-item  " role="presentation">
              <a
                class="nav-link active btn buttonTAb"
                onClick={() => {
                  click(0);
                  setCurrentPage(1);
                }}
                data-style={style[0]}
                id="buttonTAb1"
                data-bs-toggle="tab"
                data-bs-target="#Tab1"
                type="button"
                role="tab"
                aria-controls="pills-home"
                aria-selected="true"
                style={{ padding: "3px 11px" }}
              >
                تراکنش
              </a>
            </li>

            <li class="nav-item" role="presentation">
              <a
                class="nav-link btn buttonTAb"
                onClick={() => {
                  click(3);
                  setCurrentPage(1);
                }}
                data-style={style[3]}
                id="buttonTAb4"
                data-bs-toggle="tab"
                data-bs-target="#Tab4"
                type="button"
                role="tab"
                aria-controls="pills-profile4"
                aria-selected="false"
                style={{ padding: "3px 11px" }}
              >
                لیست کارت ها
              </a>
            </li>
          </>
        )}
        <li class="nav-item" role="presentation">
          <a
            class="nav-link btn buttonTAb"
            onClick={() => {
              click(1);
              setCurrentPage(1);
            }}
            data-style={style[1]}
            id="buttonTAb2"
            data-bs-toggle="tab"
            data-bs-target="#Tab2"
            type="button"
            role="tab"
            aria-controls="pills-profile"
            aria-selected="false"
            style={{ padding: "3px 11px" }}
          >
            سوابق تراکنش
          </a>
        </li>
        <li class="nav-item " role="presentation">
          <a
            class="nav-link btn buttonTAb"
            onClick={() => {
              click(2);
              setCurrentPage(1);
            }}
            data-style={style[2]}
            id="buttonTAb3"
            data-bs-toggle="tab"
            data-bs-target="#Tab3"
            type="button"
            role="tab"
            aria-controls="pills-profile6"
            aria-selected="false"
            style={{ padding: "3px 11px" }}
          >
            درخواست های برداشت
          </a>
        </li>
      </ul>

      <div class="tab-content  w-75 mx-auto " id="pills-tabContent">
        {type == 0 ? (
          <div
            class="tab-pane fade div-Shadow  active show"
            id="Tab5"
            role="tabpanel"
            aria-labelledby="pills-profile5"
          >
            <div className="d-flex flex-wrap justify-content-between">
              <div className="d-flex flex-column justify-content-between w-100 ">
                {allWallets &&
                  allWallets
                    ?.slice((currentPage - 1) * 10, (currentPage - 1) * 10 + 10)
                    .map((item, index) => (
                      <Box
                        key={index}
                        information={[
                          [
                            "نوع کیف پول",
                            item.type == 0
                              ? "کاربر"
                              : item.type == 2
                              ? item["userInfo"] && item["userInfo"].type == 0
                                ? "main shop"
                                : "shop"
                              : "گروه مارکت",
                          ],
                          [
                            "نام",
                            item["userInfo"] && item.type == 2
                              ? item.userInfo.title
                              : item["userInfo"] && item.type == 0
                              ? item["userInfo"].fname +
                                " " +
                                item["userInfo"].lname
                              : "",
                          ],
                          [
                            "موبایل",
                            item["userInfo"] && item["userInfo"].mobile,
                          ],
                          [
                            "وضعیت کیف پول",
                            item && item.main_status == 1
                              ? "غیر فعال"
                              : item && item.main_status == 0
                              ? "فعال"
                              : "",
                          ],
                          [
                            "تاریخ ساخت",
                            item.mtm != null ? date(item.mtm)[2] : "_",
                          ],
                          [
                            "موجودی کیف پول",
                            parseInt(item.current_inventory).toLocaleString(),
                          ],
                          [
                            "کل خروجی ها",
                            parseInt(item.fromWallet).toLocaleString(),
                          ],
                          [
                            "کل ورودی ها",
                            parseInt(item.toWallet).toLocaleString(),
                          ],
                        ]}
                      />
                    ))}
                <Pagination
                  className="mx-auto"
                  total={allWallets.length}
                  pageSize={6}
                  current={currentPage}
                  onChange={(newPage) => {
                    setCurrentPage(newPage);
                  }}
                ></Pagination>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div
              class="tab-pane fade div-Shadow show active"
              id="Tab1"
              role="tabpanel"
              aria-labelledby="pills-home-tab"
            >
              <div
                className="w-100 mx-auto pb-3 tabNumOne"
                style={{ borderBottom: "2px solid #303481" }}
              >
                <h4 className="text-right fw-bolder my-4">
                  <strong>شارژ کیف پول</strong>
                </h4>
                <h5>موجودی فعلی: {addCommas(current_inventor)} تومان</h5>

                <div
                  class="btn-group   d-flex flex-row justify-content-between flex-wrap w-75 mx-auto my-4 mb-2"
                  role="group"
                  aria-label="Basic checkbox toggle button group"
                >
                  <button
                    onClick={() => {
                      clickCost(0) || CostButton[0]
                        ? setcostInput(0)
                        : setcostInput(300000);
                    }}
                    className="btn btn-outline-secondary m-2 rounded-pill cost-width shadow border-0 px-4"
                    style={{
                      backgroundColor: CostButton[0] && "gray",
                      color: CostButton[0] && "white",
                    }}
                  >
                    300,000 تومان
                  </button>
                  <button
                    onClick={() => {
                      clickCost(1) || CostButton[1]
                        ? setcostInput(0)
                        : setcostInput(200000);
                    }}
                    className="btn btn-outline-secondary m-2 rounded-pill cost-width shadow  border-0  px-4"
                    style={{
                      backgroundColor: CostButton[1] && "gray",
                      color: CostButton[1] && "white",
                    }}
                  >
                    200,000 تومان
                  </button>
                  <button
                    id="btn5"
                    onClick={() => {
                      clickCost(2) || CostButton[2]
                        ? setcostInput(0)
                        : setcostInput(50000);
                    }}
                    className="btn btn-outline-secondary m-2 rounded-pill cost-width shadow border-0  d-none  px-5"
                    style={{
                      backgroundColor: CostButton[2] && "gray",
                      color: CostButton[2] && "white",
                    }}
                  >
                    50,000 تومان
                  </button>
                </div>
                <div
                  class="btn-group  text-center d-flex flex-row justify-content-between flex-wrap mx-auto my-4 mt-0"
                  role="group"
                  aria-label="Basic checkbox toggle button group"
                  style={{ width: "72%" }}
                  id="div5"
                >
                  <button
                    onClick={() => {
                      clickCost(2) || CostButton[2]
                        ? setcostInput(0)
                        : setcostInput(50000);
                    }}
                    className="btn btn-outline-secondary rounded-pill cost-width shadow border-0 px-5 w-100"
                    style={{
                      backgroundColor: CostButton[2] && "gray",
                      color: CostButton[2] && "white",
                    }}
                  >
                    50,000 تومان
                  </button>
                </div>

                <div
                  className="text-center d-flex flex-row mx-auto my-3 position-relative number-div"
                  style={{ width: "222px", height: 34 }}
                >
                  <button
                    className="btn border-none shadow-none p-0 position-absolute arrow-btn"
                    style={{ right: "7%", marginTop: "4px" }}
                    onClick={() =>
                      setcostInput(parseInt(costInput) + 10000) || clickCost(-1)
                    }
                  >
                    <FaPlus style={{ width: "20px" }} className="fs-6 " />
                  </button>
                  <input
                    // type="number"
                    style={{ width: "222px", padding: "0px 28%" }}
                    value={addCommas(costInput)}
                    onChange={(e) => {
                      setcostInput(removeCommas(e.target.value)) ||
                        clickCost(-1);
                    }}
                    className={` mx-1 ${
                      costInput == "" ? "border-0" : "border"
                    } rounded-pill shadow text-center number-input`}
                    placeholder="مبلغ های دیگر"
                  ></input>
                  <button
                    className="btn border-none shadow-none p-0 position-absolute arrow-btn"
                    style={{ left: "4%", marginTop: "4px" }}
                    onClick={() =>
                      costInput > 0
                        ? setcostInput(parseInt(costInput) - 10000) ||
                          clickCost(-1)
                        : null
                    }
                  >
                    <FaMinus style={{ width: "20px" }} className="fs-6 " />
                  </button>
                </div>
                <div className="text-end">
                  <button
                    type="button"
                    className="btn text-white border-3 border-light but-width"
                    style={{
                      backgroundColor: "green",
                      borderRadius: "10px",
                      padding: "5px 50px",
                      borderRadius: "15px",
                    }}
                    onClick={() => Charg(costInput)}
                  >
                    پرداخت
                  </button>
                </div>
              </div>
            </div>

            <div
              class="tab-pane fade div-Shadow "
              id="Tab4"
              role="tabpanel"
              aria-labelledby="pills-profile4"
            >
              <button
                className="btn btn-success "
                variant="primary"
                onClick={handleShow}
              >
                {" "}
                + ایجاد کارت
              </button>
              <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                  <Modal.Title>افزودن کارت</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <form>
                    <div className="d-flex justify-content-between my-2">
                      <label
                        className="form-label pt-1 me-1"
                        style={{ width: "100px" }}
                        htmlFor="card_owner_name"
                      >
                        نام صاحب کارت
                      </label>
                      <input
                        id="card_owner_name"
                        type="text"
                        placeholder="نام و نام خانوادگی صاحب کارت را وارد کنید"
                        className="form-control w-75 text-start"
                        style={{ height: "2rem" }}
                        value={addCard.card_owner_name}
                        onChange={(e) => {
                          setAddCard({
                            ...addCard,
                            card_owner_name: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <div className="d-flex justify-content-between my-2">
                      <label
                        className="form-label pt-1 me-1"
                        htmlFor="expiry_year"
                      >
                        {" "}
                        تاریخ انقضای کارت{" "}
                      </label>
                      <input
                        type="number"
                        placeholder="مثال : 5"
                        className="form-control w-25 text-start"
                        style={{ height: "2rem" }}
                        value={addCard.expiry_month}
                        onChange={(e) => {
                          setAddCard({
                            ...addCard,
                            expiry_month: e.target.value,
                          });
                        }}
                      />
                      <span>,</span>
                      <input
                        id="expiry_year"
                        type="number"
                        placeholder="مثال : 1401"
                        className="form-control w-25 text-start"
                        style={{ height: "2rem" }}
                        value={addCard.expiry_year}
                        onChange={(e) => {
                          setAddCard({
                            ...addCard,
                            expiry_year: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <div className="d-flex justify-content-between my-2">
                      <label
                        className="form-label pt-1 me-1"
                        htmlFor="shaba_number"
                      >
                        شماره شبا
                      </label>
                      <input
                        id="shaba_number"
                        type="number"
                        placeholder="شماره شبا را وارد کنید"
                        className="form-control w-75 text-start"
                        style={{ height: "2rem" }}
                        value={addCard.shaba_number}
                        onChange={(e) => {
                          setAddCard({
                            ...addCard,
                            shaba_number: e.target.value,
                          });
                        }}
                      />
                    </div>
                    {valid[0] && (
                      <small
                        className="text-danger"
                        style={{ marginRight: "7.5rem" }}
                      >
                        مقدار شماره شبا نامعتبر است
                      </small>
                    )}
                    <div className="d-flex justify-content-between mb-1">
                      <label
                        className="form-label pt-1 me-1"
                        htmlFor="card_number"
                      >
                        شماره حساب
                      </label>
                      <input
                        id="card_number"
                        type="number"
                        placeholder="شماره حساب خود را وارد کنید"
                        className="form-control w-75 text-start"
                        style={{ height: "2rem" }}
                        value={addCard.card_number}
                        onChange={(e) => {
                          setAddCard({
                            ...addCard,
                            card_number: e.target.value,
                          });
                        }}
                      />
                    </div>
                    {valid[1] && (
                      <small
                        className="text-danger"
                        style={{ marginRight: "7.5rem" }}
                      >
                        مقدار شماره حساب نامعتبر است
                      </small>
                    )}

                    <div className="d-flex justify-content-between my-2">
                      <label
                        className="form-label pt-1 me-1"
                        htmlFor="bank_name"
                      >
                        اسم بانک
                      </label>
                      <input
                        id="bank_name"
                        type="text"
                        placeholder="اسم بانک مرجع کارت را بنویسید"
                        className="form-control w-75 text-start"
                        style={{ height: "2rem" }}
                        value={addCard.bank_name}
                        onChange={(e) => {
                          setAddCard({
                            ...addCard,
                            bank_name: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </form>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    لغو
                  </Button>
                  <Button variant="primary" onClick={AddCard}>
                    ثبت
                  </Button>
                </Modal.Footer>
              </Modal>
              <div className="d-flex flex-column justify-content-between w-100 ">
                {cards &&
                  cards
                    ?.slice((currentPage - 1) * 10, (currentPage - 1) * 10 + 10)
                    .map((item, index) => (
                      <Box
                        key={index}
                        information={[
                          ["نام صاحب کارت", item.card_owner_name],
                          ["شماره کارت", item.card_number],
                          ["شماره شبا", item.shaba_number],
                          [
                            "وضعیت",
                            item.status == 2 || item.status == 0
                              ? "غیر فعال"
                              : item.status == 3 || item.status == 1
                              ? "فعال"
                              : "",
                          ],
                          ["اسم بانک", item.bank_name],
                          [
                            "عملیات",
                            <div className="icon  w-100 text-center ">
                              {parseInt(item.status) == 3 ? (
                                <span
                                  className=""
                                  data-tip="تغییر وضعیت"
                                  data-for="btn"
                                >
                                  <HiOutlineBan
                                    className="mx-1 tab-pane-hover"
                                    onClick={() => {
                                      UpdateCard(item.id, 0);
                                    }}
                                  ></HiOutlineBan>
                                </span>
                              ) : (
                                <span
                                  className=""
                                  data-tip="تغییر وضعیت"
                                  data-for="btn"
                                >
                                  <FaCheck
                                    className="mx-1 tab-pane-hover"
                                    onClick={() => {
                                      UpdateCard(item.id, 1);
                                    }}
                                  ></FaCheck>
                                </span>
                              )}
                            </div>,
                          ],
                        ]}
                      />
                    ))}
                <Pagination
                  className="mx-auto"
                  total={cards.length}
                  pageSize={6}
                  current={currentPage}
                  onChange={(newPage) => {
                    setCurrentPage(newPage);
                  }}
                ></Pagination>
              </div>
            </div>
          </>
        )}
        <div
          class="tab-pane fade div-Shadow "
          id="Tab2"
          role="tabpanel"
          aria-labelledby="pills-profile-tab"
        >
          <div className="d-flex flex-wrap justify-content-between">
            {Transactions &&
              Transactions?.slice(
                (currentPage - 1) * 10,
                (currentPage - 1) * 10 + 10
              ).map((item, index) => (
                <LineTransaction
                  key={index}
                  info={item}
                  type={type}
                  setUpdater={setUpdater}
                />
              ))}
            <Pagination
              className="mx-auto"
              total={Transactions.length}
              pageSize={6}
              current={currentPage}
              onChange={(newPage) => {
                setCurrentPage(newPage);
              }}
            ></Pagination>
          </div>
        </div>
        <div
          class="tab-pane fade div-Shadow "
          id="Tab3"
          role="tabpanel"
          aria-labelledby="pills-profile6"
        >
          <div className="d-flex flex-wrap justify-content-between">
            {type != 0 && (
              <>
                <div
                  className="w-75 mx-auto pb-5 tabNumOne "
                  // style={{ borderBottom: "2px solid #303481" }}
                >
                  {time[2] == 1 || time[2] == 10 || time[2] == 20 ? (
                    ""
                  ) : (
                    <small className="text-right fw-bolder my-4 text-warning fs-6">
                      برداشت فقط در روز های اول ماه به طور کامل و ۱۰ام و ۲۰ام به
                      مقدار ۶۰٪ موجودی میباشد .
                    </small>
                  )}
                  <h4 className="text-right fw-bolder my-4">انتقال به کارت</h4>
                  <div className="d-flex flex-row w-100 justify-content-around flex-wrap">
                    <div className="input-width " style={{ width: "17rem" }}>
                      <label className="form-label mb-0" htmlFor="cart">
                        شماره کارت مقصد را ارسال کنید
                      </label>
                      <div
                        className=" position-relative mb-5"
                        style={{ width: "100%", marginTop: "5px" }}
                      >
                        {bank != [] && (
                          <CreatableSelect
                            placeholder={" انتخاب شماره کارت"}
                            options={bank}
                            value={selectNumber}
                            className="text-dark user-label mt-1 shadow"
                            onChange={(e) => {
                              setSelectNumber(e);
                            }}
                            input={{ borderRadius: "20px" }}
                            container={{ borderRadius: "20px" }}
                            styles={{ borderRadius: "10px" }}
                            isDisabled={
                              !(time[2] == 1 || time[2] == 10 || time[2] == 20)
                            }
                          />
                        )}
                      </div>
                    </div>

                    <div className="input-width">
                      <label className="form-label mb-2" for="cost">
                        مبلغ انتقال را وارد کنید
                      </label>
                      <div className=" position-relative">
                        <input
                          disabled={
                            !(time[2] == 1 || time[2] == 10 || time[2] == 20)
                          }
                          // type="number"
                          dir="ltr"
                          id="cost"
                          value={addCommas(Input2)}
                          className="form-control h-25 inputs rounded-pill shadow "
                          onChange={(e) => {
                            if (time[2] == 1) {
                              if (
                                removeCommas(e.target.value) > current_inventor
                              ) {
                                toast.error("مبلغ، از موجودی شما بیشتر است", {
                                  position: "top-center",
                                });
                                setInput2(removeCommas(Input2));
                              } else {
                                setInput2(removeCommas(e.target.value));
                              }
                            }
                            if (time[2] == 10 || time[2] == 20) {
                              if (
                                removeCommas(e.target.value) >
                                current_inventor * 0.6
                              ) {
                                toast.error(
                                  "شما فقط میتوانید شصت درصد از موجودی خود را برداشت کنید",
                                  {
                                    position: "top-center",
                                  }
                                );
                                setInput2(removeCommas(Input2));
                              } else {
                                setInput2(removeCommas(e.target.value));
                              }
                            }
                          }}
                          style={{ width: "260px" }}
                        />
                        {/* <span
                    className="position-absolute bg-white p-1 labell"
                    style={{ top: "-20px", fontSize: "15px", right: "10px" }}
                  >
                    مبلغ
                  </span> */}
                      </div>
                    </div>
                  </div>

                  <div className="text-end">
                    <button
                      disabled={
                        !(time[2] == 1 || time[2] == 10 || time[2] == 20)
                      }
                      type="button"
                      onClick={() => {
                        if (Input2 == "" || selectNumber == "") {
                          toast.error(
                            "شماره کارت مقصد و مبلغ انتفال نمیتوانند خالی باشند",
                            {
                              position: "top-center",
                            }
                          );
                        } else if (Input2 > current_inventor) {
                          toast.error("مبلغ انتفال از موجودی شما بیشتر است", {
                            position: "top-center",
                          });
                        } else if (
                          Input2 != "" &&
                          selectNumber != "" &&
                          Input2 < current_inventor
                        ) {
                          // InventoryUpdate();
                          TransferTo(selectNumber.value, Input2);
                        }
                      }}
                      className="btn text-white border-3 border-light mt-3 but-width"
                      style={{
                        backgroundColor: "green",
                        borderRadius: "10px",
                        padding: "5px 60px",
                        borderRadius: "15px",
                      }}
                    >
                      ثبت
                    </button>
                  </div>
                </div>
              </>
            )}
            <hr className="w-100 bg-black" />
            {Transactions2 &&
              Transactions2?.slice(
                (currentPage - 1) * 10,
                (currentPage - 1) * 10 + 10
              ).map((item, index) => (
                <Transa
                  key={index}
                  info={item}
                  type={type}
                  updater={updater}
                  setUpdater={setUpdater}
                />
              ))}
            <Pagination
              className="mx-auto"
              total={Transactions2.length}
              pageSize={6}
              current={currentPage}
              onChange={(newPage) => {
                setCurrentPage(newPage);
              }}
            ></Pagination>
          </div>
        </div>
      </div>

      {/* <!--toast notif--> */}
      <ToastContainer />
    </div>
  );
}
